export enum ESprites {
  CARDS = 'sprite-cards',
  FLAGS = 'sprite-flags',
  SOCIALS = 'sprite-socials',
  UI = 'sprite-ui'
}

export enum ESpritesSocials {
  FACEBOOK = 'icon-facebook',
  INSTAGRAM = 'icon-instagram',
  WHATSAPP = 'icon-whatsapp',
  TWITTER = 'icon-twitter',
  MESSENGER = 'icon-messenger',
  WAZE = 'icon-waze'
}

export enum ESpritesUI {
  RECHARGINE = 'ui-send-rechargine',
  INVOICES = 'ui-paid-invoices',
  SLIM = 'ui-slim-fundation',
  HTECH = 'ui-secure-htech',
  WARNING = 'ui-warning',
  CHECKMARK = 'ui-checkmark',
  CLARO = 'ui-claro',
  ARROW = 'ui-arrow-right'
}

export enum ESpritesCards {
  VISA = 'logo-visa',
  MASTERCARD = 'logo-mastercard',
  AMEX = 'logo-amex'
}

export enum ESpritesFlags {
  COSTA_RICA = 'flag-cr',
  USA = 'flag-us',
  NICARAGUA = 'flag-ni',
  HONDURAS = 'flag-hn',
  GUATEMALA = 'flag-gt',
  EL_SALVADOR = 'flag-sv'
}
